/* 🤖 this file was generated by svg-to-ts */
export const iccIconOpenFolder: {
  name: 'open_folder';
  data: string;
} = {
  name: 'open_folder',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm0 12H4V8h16v10Z" fill="currentColor"/></svg>`
};
